/* Happymami · Tienda — desplegables (guía y preguntas frecuentes).
   Se despliegan con animación de altura y, dentro de una misma sección, al abrir uno se pliega el que estaba abierto.
   Sigue siendo <details>/<summary> (teclado, lectores de pantalla y texto visible para buscadores). Sin librerías. */
(function () {
  'use strict';
  if (window.__hmTiendaAcordeon) return;
  window.__hmTiendaAcordeon = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22,1,.36,1)';

  function bodyOf(d) { return d.querySelector('.body'); }

  function openIt(d) {
    var b = bodyOf(d);
    if (d.__anim) { d.__anim.cancel(); d.__anim = null; }
    d.classList.remove('is-closing');
    d.open = true;
    if (!b || reduce || !b.animate) return;
    var h = b.offsetHeight;
    b.style.overflow = 'hidden';
    d.__anim = b.animate(
      [{ height: '0px', opacity: 0, paddingBottom: '0px' }, { height: h + 'px', opacity: 1, paddingBottom: getComputedStyle(b).paddingBottom }],
      { duration: 380, easing: EASE }
    );
    var done = function () { b.style.overflow = ''; d.__anim = null; };
    d.__anim.onfinish = done;
    d.__anim.oncancel = done;
  }

  function closeIt(d) {
    var b = bodyOf(d);
    if (!d.open) return;
    if (d.__anim) { d.__anim.cancel(); d.__anim = null; }
    if (!b || reduce || !b.animate) { d.open = false; return; }
    d.classList.add('is-closing');
    var h = b.offsetHeight;
    b.style.overflow = 'hidden';
    d.__anim = b.animate(
      [{ height: h + 'px', opacity: 1, paddingBottom: getComputedStyle(b).paddingBottom }, { height: '0px', opacity: 0, paddingBottom: '0px' }],
      { duration: 300, easing: EASE }
    );
    d.__anim.onfinish = function () {
      d.open = false;
      d.classList.remove('is-closing');
      b.style.overflow = '';
      d.__anim = null;
    };
    d.__anim.oncancel = function () { b.style.overflow = ''; };
  }

  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('.hm-det > summary');
    if (!sum) return;
    var d = sum.parentNode;
    e.preventDefault();
    if (d.open && !d.classList.contains('is-closing')) {
      closeIt(d);
      return;
    }
    // Dentro de la misma sección (guía o preguntas) solo uno abierto a la vez.
    var group = d.closest('.hm-guide-grid, .hm-faq-list');
    if (group) {
      [].forEach.call(group.querySelectorAll('.hm-det[open]'), function (o) { if (o !== d) closeIt(o); });
    }
    openIt(d);
  });
})();
